import DashboardEdit from './DashboardEdit'

export default DashboardEdit
